import React from 'react';
import Link from 'next/link';
import ReactStars from 'react-stars';
import moment from 'moment';
import IconUser from '../UI/Icons/IconUser';

const ReviewItem = ({
  username,
  rating,
  content,
  date,
}) => (
  <div className="review">
    <div className="review__header">
      <div className="review__header__avatar">
        <IconUser color="#141029" />
      </div>
      <div>
        <Link href="">
          <a className="review__header__username">{username}</a>
        </Link>
        <div className="review__header__rating">
          <ReactStars
            count={5}
            size={12}
            color2="#ffd700"
            value={rating}
            edit={false}
          />
          <span>{rating}</span>
        </div>
      </div>
    </div>
    <div className="review__content">{content}</div>
    {/* TODO: Perhaps useful in the future */}
    {/*<div className="review__info">*/}
    {/*  <span>*/}
    {/*    Speed*/}
    {/*    {' '}*/}
    {/*    <b>4.6</b>*/}
    {/*  </span>*/}
    {/*  <span>*/}
    {/*    Сonvenience*/}
    {/*    {' '}*/}
    {/*    <b>4.6</b>*/}
    {/*  </span>*/}
    {/*</div>*/}
    <div className="review__footer">
      <span>{moment(date).utc().format('DD MMM YYYY h:mm a')}</span>
      {/* TODO: Perhaps useful in the future */}
      {/*<button*/}
      {/*  type="button"*/}
      {/*  className="review__more"*/}
      {/*>*/}
      {/*  Read*/}
      {/*</button>*/}
    </div>
  </div>
);

export default ReviewItem;
